import React from "react";

const PirateFlag = ({ isYellow = false }) => {
  const rootClassName = isYellow
    ? "pirate-flag pirate-flag--map"
    : "pirate-flag";

  return (
    <div className={rootClassName}>
      <div className="column-flag">
        <div className="pirate-flag-column-0"></div>
        <div className="pirate-flag-column-0bis"></div>
        <div className="pirate-flag-column-1"></div>
        <div className="pirate-flag-column-2"></div>
      </div>

      <div className="column-flag">
        <div className="pirate-flag-column-3"></div>
        <div className="pirate-flag-column-4"></div>
        <div className="pirate-flag-column-5"></div>
        <div className="pirate-flag-column-6"></div>
      </div>

      <div className="column-flag">
        <div className="pirate-flag-column-7"></div>
        <div className="pirate-flag-column-8"></div>
        <div className="pirate-flag-column-9"></div>
        <div className="pirate-flag-column-10"></div>
      </div>

      <div className="column-flag">
        <div className="pirate-flag-column-11"></div>
        <div className="pirate-flag-column-12"></div>
        <div className="pirate-flag-column-13"></div>
        <div className="pirate-flag-column-14"></div>
      </div>

      <div className="column-flag">
        <div className="pirate-flag-column-14"></div>
        <div className="pirate-flag-column-13"></div>
        <div className="pirate-flag-column-12"></div>
        <div className="pirate-flag-column-11"></div>
      </div>

      <div className="column-flag">
        <div className="pirate-flag-column-10"></div>
        <div className="pirate-flag-column-9"></div>
        <div className="pirate-flag-column-8"></div>
        <div className="pirate-flag-column-7"></div>
      </div>

      <div className="column-flag">
        <div className="pirate-flag-column-6"></div>
        <div className="pirate-flag-column-5"></div>
        <div className="pirate-flag-column-4"></div>
        <div className="pirate-flag-column-3"></div>
      </div>

      <div className="column-flag">
        <div className="pirate-flag-column-2"></div>
        <div className="pirate-flag-column-1"></div>
        <div className="pirate-flag-column-0bis"></div>
        <div className="pirate-flag-column-0"></div>
      </div>
    </div>
  );
};

export default PirateFlag;
